// extracted by mini-css-extract-plugin
module.exports = {"floating":"styles_floating__O7l3N","floatingHidden":"styles_floatingHidden__Xa4S_"};